import React, { Component } from 'react';
import RequestManager from '../../requests/RequestManager';
import LinealPredictiveV1Task from '../../requests/tasks/search/v1/LinealPredictiveV1Task';
import UtilsSearch from './UtilsSearch';
import ChunkerSearch from './ChunkerSearch';
import SearchConstants from './SearchConstants';
import ComponentsSearch from './components/ComponentsSearch';
import {getBookmark, getMultiplePBIS, getMultiContentSearch, contentData} from '../../requests/loader';
import { connect } from 'react-redux';
import { playFullMedia, playCatchupEvent } from '../../actions/playmedia';
import { Dates } from '../../packages/dates/lib/dates';
import {convertEventLiveTORecord} from './ObserversSearch';
import ListRanking from '../../requests/tasks/search/ListRanking';
import store from './../../store';
import logger from 'src/utils/logger/logger';

const UP_DIRECTION = 'up';
const DOWN_DIRECTION = 'down';
const RIGHT_DIRECTION = 'right';


class SearchContent extends Component {
    constructor(props) {
        super();
        this.state = {
            items: [],
            bookmark: [],
            contentPlay: {},
            contentsearch: [],
            dataServicePopularItems: {response:{}},
            showTextNoFoundAPI: false
        };
        this.chunker = null;
        this.showPlay = null;
    }

    componentDidMount = () => {
        this.addListeners();
        if(window && !window.__localeId__){
            // Se establece el idioma
            new Dates().locale('es');
        }
        const auxWordsSearch = UtilsSearch.getWordsStorage();
        !auxWordsSearch && this.getPopularItems();
        convertEventLiveTORecord.subscribe(this.convertEventToRecord);
    };

    convertEventToRecord = (item) =>{
        if(this.chunker && (typeof this.chunker.getAllElements === 'function')){
            const allElements = this.chunker.getAllElements();
            // no hay nada que hacer update
            if(Array.isArray(allElements) && allElements.length === 0) return;
            const {id = null, type = null, from = null, list = []} = item;
            if(id && type){
                    if((typeof this.chunker.updateElementbyIndex === 'function')){
                        if(type === SearchConstants.RECORDING){
                            const findElement = allElements.findIndex(el =>  el.id == id && el.content_type === SearchConstants.EVENT);
                            this.chunker.updateElementbyIndex(findElement,SearchConstants.KEY_CONTENT_TYPE, SearchConstants.RECORDING);
                            this.renderCurrentElement();
                            return;
                        }
                        if(type === SearchConstants.EVENT){
                            const findElement = allElements.findIndex(el =>  el.id == id && el.content_type === SearchConstants.RECORDING);
                            this.chunker.updateElementbyIndex(findElement,SearchConstants.KEY_CONTENT_TYPE, SearchConstants.EVENT);
                            this.renderCurrentElement();
                            return;
                        }
                    }
            }
            if(from && from === SearchConstants.FROM_SERIES && Array.isArray(list) && list.length > 0){
                for(const l in list){
                    const item = list[l];
                    if(item.id && (typeof this.chunker.updateElementbyIndex === 'function')){
                        const findElement = allElements.findIndex(el =>  el.id == item.id && el.content_type === SearchConstants.EVENT);
                        this.chunker.updateElementbyIndex(findElement,SearchConstants.KEY_CONTENT_TYPE, SearchConstants.RECORDING);
                    }
                }
                this.renderCurrentElement();
                return;
            }
        }
    }

    componentWillUnmount = () => {
        this.removeListeners();
        convertEventLiveTORecord.unsubscribe(this.convertEventToRecord)
    };

    addListeners = () => {
        const x = Array.from(document.getElementsByClassName('aaf_main_search_container_results'));
        if (x && Array.isArray(x) && x[0]) {
            const element = x[0];
            element && typeof element.addEventListener === 'function' &&element.addEventListener('sn:focused', this.hasFocused);
        }
    };

    removeListeners = () => {
        const x = Array.from(document.getElementsByClassName('aaf_main_search_container_results'));
        if (x && Array.isArray(x) && x[0]) {
            const element = x[0];
            element && typeof element.removeEventListener === 'function' && element.removeEventListener('sn:focused', this.hasFocused);
        }
    };

    hasFocused = (e) => {
        if(e && e && e.detail){
            // SI VENGO DESDE UN CARROUSEL

            if(e.detail.previousElement && e.detail.direction === RIGHT_DIRECTION && e.target){
                this.setFirstFocus(e.detail.previousElement, e.target);
            }
            //MOVIEMIENTOS ARRIBA Y ABAJO
            if(e.detail.direction){
                if(e.detail.direction === DOWN_DIRECTION){
                    this.downElements(e);
                }
                if(e.detail.direction === UP_DIRECTION){
                    this.upElements(e);
                }

            }
        }
    };

    downElements = (e) => {
        if (e && e.target && typeof e.target.getAttribute == 'function' &&  e.target.getAttribute('data-id')) {
            const target = e.target.getAttribute('data-id');
            const idx = parseInt(target) || 0;
            // YA QUE TENEMOS EL ID PROXIMO, SETEAMOS EN EL CHUNKER PARA QUE A PARTIR DE AHI TOMEMOS LOS DATOS EN EL ARREGLO
            this.setNewIndexInChunker(idx);
            // TOMAMOS LOS SIGUIENTE ELEMENTOS
            const downElements = this.chunker.current() || [];
            const {items = []} = downElements;

            // OBTENEMOS EL ELEMENTO ANTERIOR PARA SABER SI VENIMOS DESDE UN BOTON O UN CARD =/
            let previusElement = e.detail && e.detail.previousElement;
            if(previusElement && typeof previusElement.getAttribute == 'function'){
                const idPrev = previusElement.getAttribute('data-id');
                if(idPrev === null) return;
                const id = parseInt(idPrev);
                const from_focus = previusElement.getAttribute('data-from-focusable');
                const previous_params = {
                    id,
                    from_focus
                }
                this.setStateItems(items, target, DOWN_DIRECTION, previous_params);
            }
        }
    };

    renderCurrentElement = () =>{
        const currentElements = this.chunker.current() || [];
        const {items = []} = currentElements;
        if(items){
            this.setStateItems(items, null);
        }
    }

    upElements = (e) =>{
        //OBTENIENDO LA DATA DEL ELEMENTO PREVIO
        if (e && e.detail && e.detail.previousElement && typeof e.detail.previousElement.getAttribute == 'function') {
            const target = e.detail.previousElement.getAttribute('data-id');
            const idx = parseInt(target) || 0;
            if(idx === 0) return;
             // YA QUE TENEMOS EL ID PROXIMO, SETEAMOS EN EL CHUNKER PARA QUE A PARTIR DE AHI TOMEMOS LOS DATOS EN EL ARREGLO
             this.setNewIndexInChunker(idx - 1);
             const upElements = this.chunker.current() || [];
             const {items = []} = upElements;
             const from_focus = e.detail.previousElement.getAttribute('data-from-focusable');
             const previous_params = {
                id: idx,
                from_focus
            }
            this.setStateItems(items, target, UP_DIRECTION, previous_params);
        }

    }

    setFirstFocus = (previus, target)=>{
        if(!(target.classList && target.classList.contains && (typeof target.classList.contains === 'function') && target.classList.contains('focusable_search'))) return;

        //METODO SI VIENE DE KEYBOARD A ELEMENTOS BUSCADOS
        const x = Array.from(document.getElementsByClassName('aff_main_component_search_main'));
        if (x && Array.isArray(x) && x[0] && (previus.classList && previus.classList.contains && (typeof previus.classList.contains === 'function') && previus.classList.contains('aaf_keyboard-key'))) {
            const tmpDom = x[0];
            const focusElements = Array.from(tmpDom.getElementsByClassName('focusable'));
            if (focusElements && Array.isArray(focusElements) && focusElements[0]) {
                SpatialNavigation.focus(focusElements[0]);
            }
        }
    }

    setNewIndexInChunker = (idx) =>{
        if(this.chunker && typeof this.chunker.setIndex === 'function'){
            this.chunker.setIndex(idx);
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if (this.props.search === nextProps.search || nextProps.search === '') {
            return true;
        } else {
            return false;
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.search !== this.props.search) {
            if (nextProps.search === '') {
                this.props.changeTextSearch(SearchConstants.SEARCH_EMPTY);
                // this.props.changeTextSearch(SearchConstants.SEARCH_POPULAR);
                this.getPopularItems();
            } else {
                this.getData(nextProps.search);
            }
        }
    }

    getValueIsKids = () => {
        const { is_kids } = store.getState().user;
        const isKids = is_kids === 'true' || is_kids === true ? 1 : 0;
        return isKids;
    };

    handleErrorsPopularItems = () => {
      const {listRanking = {}} = store.getState().searcher;
      const data = listRanking && listRanking.response ? listRanking.response : {};
      const dataGroup = listRanking && listRanking.response && listRanking.response.groups ? listRanking.response.groups : [];
      if(dataGroup.length > 0){
        const parseResult = UtilsSearch.parseResponse(data);
        this.setChunker(parseResult);
      }else {
        this.setState({showTextNoFoundAPI: true});
      }
    };

    getPopularItems(){
        const is_kids = this.getValueIsKids();
        const RankingTask = new  ListRanking({
            is_kids,
        });

        RequestManager.addRequest(RankingTask)
        .then((data) => {
          if(data && data.response && data.response.errors){
            this.handleErrorsPopularItems();
          }else if(data && data.response && data.response.groups && Array.isArray(data.response.groups)){
            UtilsSearch.updateDataStoreSearcher({listRanking: data})
            const parseResult = UtilsSearch.parseResponse(data.response);
            this.setChunker(parseResult);
          }else{
            this.handleErrorsPopularItems();
          }
        })
        .catch((error) => {
          this.handleErrorsPopularItems();
        });
    }

    NoFoundWhenIsKids = (error = {}) =>{
      const { response: {errors = []} = {} } = error;

      errors.length > 0 && errors[0].code === SearchConstants.MESSAGE_ERROR_NOT_AVAILABLE_ANY_PROFILE
      ? this.props.changeTextSearch(SearchConstants.SEARCH_NOT_FOUND)
      : this.props.changeTextSearch(SearchConstants.SEARCH_NOT_FOUND_KIDS);

      this.getPopularItems();
    }

     validateTimesCurrentContent = (start) => {
        return new Date(start * 1000).toISOString();
    };



    canShowChannel(parseResult){
        //Quitamos del resultado de busqueda canales que no tengan timeshift y que tengan programas pasados
        return parseResult.filter((content) => {
          if((content.content_type === SearchConstants.CHANNEL && content.actual_event)|| content.content_type === SearchConstants.EVENT){
            if(UtilsSearch.filterChannelsWithOutTimeshift(content)) return content;
            else return null;
          }
          return content;
        });
    }

    handleErrorsLinealPredictive = () => {
      this.props.changeTextSearch(SearchConstants.SEARCH_POPULAR);
      const parseResult = UtilsSearch.parseResponse({});
      this.setChunker(parseResult);
    };

    convertActualEvent(parseResult, type){
        const typeContent = type === SearchConstants.NEW ? SearchConstants.CHANNEL : SearchConstants.NEWEVENT;
        const typeChangeContent = type === SearchConstants.NEW ? SearchConstants.NEWEVENT : SearchConstants.CHANNEL;

        const result = parseResult && parseResult.filter((element) =>{
            if(element.content_type === typeContent && element.actual_event === null){
                element.content_type = typeChangeContent;
                return element;
            }else{
                return element;
            }
        });
        return result;
    }

    orderVOD(filterMovies = []){
        const addOn = filterMovies.filter((element) => element.proveedor_code !== SearchConstants.AMCO);
        const amcoSusc = filterMovies.filter((element) => element.proveedor_code === SearchConstants.AMCO
        && element.format_types.includes(SearchConstants.SUBSCRIPTION));
        const amcoPPE = filterMovies.filter((element) => element.proveedor_code === SearchConstants.AMCO
        && !element.format_types.includes(SearchConstants.SUBSCRIPTION));

        return [...amcoSusc, ...addOn, ...amcoPPE]
    }

    orderResult(parseResult){
        const changeResult = this.convertActualEvent(parseResult, SearchConstants.NEW);
        const ordenamiento = {P: 1, S: 2, E: 3, L: 4, Z: 5, TALENT: 6};
        const resultFilter =   changeResult ? (changeResult.sort(((a, b) => ordenamiento[a.content_type] - ordenamiento[b.content_type]))) : null;
        const resultWhitOrder = this.convertActualEvent(resultFilter, SearchConstants.OLD);

        const vod = resultWhitOrder.filter((element) => element.content_type === SearchConstants.MOVIE
        || element.content_type === SearchConstants.SERIE);
        const notVod = resultWhitOrder.filter((element) => element.content_type !== SearchConstants.MOVIE
        && element.content_type !== SearchConstants.SERIE);

        return [...this.orderVOD(vod), ...notVod];
    }

    getData = (text) => {
      const { lastTouchSeen } = this.state;
        const is_kids = this.getValueIsKids();
        const searchTask = new LinealPredictiveV1Task({ value: text, is_kids });
        RequestManager.addRequest(searchTask)
            .then( async (result) => {
                if (result && result.response) {
                    let parseResult = UtilsSearch.parseResponse(result.response);
                    parseResult = this.orderResult(parseResult);
                    parseResult = this.canShowChannel(parseResult); // Se quitan del resultado de la busqueda los canales que no tengan timeshift
                    const resultHaveError = result && result.response && result.response.errors;
                    const resultHaveGroups = parseResult && Array.isArray(parseResult) && parseResult.length > 0;
                    try {
                        if (this.props.search !== text) return;
                        this.setState({showTextNoFoundAPI: false});;
                        if(parseResult && Array.isArray(parseResult) && parseResult.length === 0){
                            // NO SE ENCONTRARON RESULTADOS
                            this.props.changeTextSearch(SearchConstants.SEARCH_NOT_FOUND);
                            this.getPopularItems();
                            return;
                        }else{
                        // Se Enconntraron resultados
                        if(resultHaveGroups && !resultHaveError){
                          // Se Enconntraron resultados
                            this.props.changeTextSearch(SearchConstants.SEARCH_FOUND);
                            this.getMultiContentSearch(parseResult);
                            await this.getBookmark(parseResult, lastTouchSeen);
                            await this.getPBIS(parseResult);
                            this.setChunker(parseResult);

                            return;
                        }else if(!resultHaveGroups && !resultHaveError){
                          // NO SE ENCONTRARON RESULTADOS
                          this.props.changeTextSearch(SearchConstants.SEARCH_NOT_FOUND);
                          this.getPopularItems();
                        }
                        else{
                          // MANDA ERROR EL SERVICIO EN EL RESPONSE
                          this.handleErrorsLinealPredictive();
                          this.setState({showTextNoFoundAPI: true});
                        }}
                    } catch (error) {
                        logger.debug('[SEARCH]-error in LinealPredictive' + error);
                        this.handleErrorsLinealPredictive();
                        this.setState({showTextNoFoundAPI: true});
                    }
                }
            })
            .catch((error) => {
                is_kids === 1 && this.NoFoundWhenIsKids(error)
                logger.debug('[SEARCH]-error', error);
                this.handleErrorsLinealPredictive();
                this.setState({showTextNoFoundAPI: true});
            });
    };

    isAnonymous = () => this.props && this.props.user && this.props.user.isAnonymous;

    // Obteniendo el bookmark para vod y serie
    getPBIS = async (parseResult) => {
        let groupIds = [];
        if(parseResult && Array.isArray(parseResult)){
            groupIds =  parseResult.filter(ep => {
                //FILTRAMOS LOS ELEMENTOS QUE SOLO SON SERIES Y PELICULAS
                return ep.content_type && (ep.content_type === SearchConstants.SERIE || ep.content_type === SearchConstants.MOVIE)
            });

            groupIds = groupIds.filter((element) =>{
                return (element.id && !isNaN(element.id)) || (element.group_id && !isNaN(element.group_id));
            });
            groupIds = groupIds.map((element) =>{
                // OBTENEMOS LOS GROUPIDS o IDS
                return element.id;
            });
            if(groupIds && Array.isArray(groupIds) && groupIds.length > 0){
                // // groupIds = [768906,768884,769088,768886,768837,768926,768911,768864,768912,768927,768907,768908,768921,769156,769209,769169,769204,769171,769219,769183,769168];
                // groupIds = [850972];
                await getMultiplePBIS(groupIds).then(response =>{
                    const { data: {listButtons = {}} = {}} = response || {};
                    this.setState({contentPlay: listButtons});
                }).catch(e =>{
                    logger.debug('[SEARCH]-error-PBIS', e);
                })
            }
        }
    };

    // Obteniendo el bookmark para vod y serie
    getBookmark = async (parseResult) => {
        let groupIds = [];
        if (this.isAnonymous()){
            this.setState({bookmark: []});
            return;
        }
        if(parseResult && Array.isArray(parseResult)){

             //FILTRAMOS LOS ELEMENTOS QUE SOLO SON SERIES Y PELICULAS Y OBTENEMOS LOS GROUPIDS
            groupIds = this.getFiltersGroupsIdsVOD(parseResult);

            if(groupIds && Array.isArray(groupIds) && groupIds.length > 0){
                groupIds = groupIds.join(',');
                const { lastTouchSeen } = this.state;
                await getBookmark(groupIds, lastTouchSeen).then(bookmark =>{
                    const { response: { groups = [] } = {} } = bookmark;
                    this.setState({bookmark: groups});
                }).catch(e =>{
                    logger.debug('[Bookmar]-error', e);
                })
            }
        }
    };

    getMultiContentSearch = (parseResult) => {
        let groupIds = [];
        let formatTypes = null;
        if(parseResult && Array.isArray(parseResult)){
            //FILTRAMOS LOS ELEMENTOS QUE SOLO SON SERIES Y PELICULAS Y OBTENEMOS LOS GROUPIDS
            groupIds = this.getFiltersGroupsIdsVOD(parseResult);
            formatTypes = this.getFormatTypes(parseResult);
            if(formatTypes!==null){
                getMultiContentSearch({groupIds, formatTypes}).then(contentsearch =>{
                    const { data  } = contentsearch;
                    this.setState({contentsearch: Object.entries(data)});
                }).catch(e =>{
                    logger.debug('[Bookmar]-error', e);
                })
           }else{
            this.setState({contentsearch: []});
           }
        }
    }

    getFiltersGroupsIdsVOD(parseResult){
        let groupIds = [];

        const elementsVOD =  parseResult.filter(ep => {
            //FILTRAMOS LOS ELEMENTOS QUE SOLO SON SERIES Y PELICULAS
            return ep.content_type && (ep.content_type === SearchConstants.SERIE || ep.content_type === SearchConstants.MOVIE)
        });
        groupIds = elementsVOD.map((element) =>{
            // OBTENEMOS LOS GROUPIDS
            return element.id;
        });

        return groupIds
    }

    getFormatTypes(parseResult){
        let extraParams = null;
        let contentTypes = null;

        const elementsVOD =  parseResult.filter(ep => {
            //FILTRAMOS LOS ELEMENTOS QUE SOLO SON SERIES Y PELICULAS
            return ep.content_type && (ep.content_type === SearchConstants.SERIE || ep.content_type === SearchConstants.MOVIE)
        });

        extraParams = elementsVOD.map( function(obj){
            if(obj !== null){
               return  `"${obj.id}":{"format_types":"${obj.format_types.toString()}"}`
            }
        });

        for (let i = 0; i <= extraParams.length-1; i++) {
            if(i===0){
                contentTypes = `${extraParams[i]},`
            }else if(i>0 && i<=extraParams.length-2) {
                contentTypes = contentTypes+`${extraParams[i]},`
            }else if(i===extraParams.length-1){
                contentTypes = contentTypes+`${extraParams[i]}}}`
            }
        }

        contentTypes = contentTypes !== null ? `${'{"group_ids":{'}${contentTypes}` : null
        return contentTypes;
    }

    setChunker = (result) => {
        this.chunker = null;
        let itemsRender = [];
        this.chunker = new ChunkerSearch(result, SearchConstants.quantity);
        const all_items = this.chunker.current();
        const { items = [] } = all_items;
        itemsRender = items;
        this.setStateItems(itemsRender);
    };

    setStateItems = (items, target, direction, previous_params) => {
        this.setState({
                items,
            },() => {
                if(!target){
                    window.SpatialNavigation.makeFocusable();
                }
                else{
                    if(direction === DOWN_DIRECTION){
                        this.focusDownDirection(items,previous_params);
                    }
                    if(direction === UP_DIRECTION){
                        this.focusUpDirection(items,previous_params);
                    }
                }
            }
        );
    };

    focusUpDirection = (items, previous_params) =>{
        const item = Array.isArray(items) && items[0] || null;
        if(previous_params && previous_params.from_focus === SearchConstants.FOCUSABLE_CARD && item){
            // SE FOCUSEA UN ELEMENTO CARD HACIA ABAJO.
            const element = document.getElementById(`${SearchConstants.FOCUSABLE_CARD}_${item.idx_temp}`);
            if(element){
                    window.SpatialNavigation.makeFocusable();
                    window.SpatialNavigation.focus(element);
            }
        }

        if(previous_params && previous_params.from_focus === SearchConstants.FOCUSABLE_BUTTON && item){
            let element =  null;
            if(item.content_type && (item.content_type === SearchConstants.MOVIE || item.content_type === SearchConstants.SERIE || item.content_type === SearchConstants.TALENT || item.content_type === SearchConstants.CHANNEL)){
                // SI VIENE DESDE UN BOTON, Y EL CONTENIDO QUE SIGUE TIENE UN BOTON, SE FOCUSEA EL BOTON
                element = document.getElementById(`${SearchConstants.FOCUSABLE_BUTTON}_${item.idx_temp}`);
            }else{
                // SI VIENE DESDE UN BOTON, Y EL CONTENIDO QUE SIGUE TIENE NO TIENE UN BOTON, SE FOCUSEA LA CARD
                element = document.getElementById(`${SearchConstants.FOCUSABLE_CARD}_${item.idx_temp}`);
            }
            if(element){
                window.SpatialNavigation.makeFocusable();
                window.SpatialNavigation.focus(element);
            }
        }
    }

    focusDownDirection = (items, previous_params) =>{
        const item = Array.isArray(items) && items[0] || null;
        if(previous_params && previous_params.from_focus === SearchConstants.FOCUSABLE_CARD && item){
            // SE FOCUSEA UN ELEMENTO CARD HACIA ABAJO.
            const element = document.getElementById(`${SearchConstants.FOCUSABLE_CARD}_${item.idx_temp}`);
            if(element){
                    window.SpatialNavigation.makeFocusable();
                    window.SpatialNavigation.focus(element);
            }
        }

        if(previous_params && previous_params.from_focus === SearchConstants.FOCUSABLE_BUTTON && item){
            let element =  null;
            if(item.content_type && (item.content_type === SearchConstants.MOVIE || item.content_type === SearchConstants.SERIE || item.content_type === SearchConstants.TALENT || item.content_type === SearchConstants.CHANNEL)){
                // SI VIENE DESDE UN BOTON, Y EL CONTENIDO QUE SIGUE TIENE UN BOTON, SE FOCUSEA EL BOTON
                element = document.getElementById(`${SearchConstants.FOCUSABLE_BUTTON}_${item.idx_temp}`);
            }else{
                // SI VIENE DESDE UN BOTON, Y EL CONTENIDO QUE SIGUE TIENE NO TIENE UN BOTON, SE FOCUSEA LA CARD
                element = document.getElementById(`${SearchConstants.FOCUSABLE_CARD}_${item.idx_temp}`);
            }
            if(element){
                window.SpatialNavigation.makeFocusable();
                window.SpatialNavigation.focus(element);
            }
        }
    }

    render() {
        const { items = [], bookmark =[], contentPlay = {}, contentsearch = {}, showTextNoFoundAPI = false} = this.state;
        return <ComponentsSearch onFocus = {this.props.onFocus} items={items} bookmark={bookmark} contentPlay={contentPlay} changeRoute={this.props.changeRoute || null} playFullMedia={this.props.playFullMedia} user={this.props.user} contentsearch={contentsearch} showTextNoFoundAPI = {this.props.search === '' ? false : showTextNoFoundAPI }  textAPIError = {this.props.textAPIError}/>;
    }
}

const mapStateToProps = (state) => ({
    user: state.user
});

const mapDispatchToProps = {
    playFullMedia,
    playCatchupEvent
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchContent);




// WEBPACK FOOTER //
// ./src/containers/Search/SearchContent.jsx